/* unplugin-vue-components disabled */import script from "./PointsMall.vue?vue&type=script&setup=true&name=PointsMall&lang=js"
export * from "./PointsMall.vue?vue&type=script&setup=true&name=PointsMall&lang=js"

import "./PointsMall.vue?vue&type=style&index=0&id=341b61eb&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341b61eb"]])

export default __exports__